import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "shouldShowTooltip", "getTooltipPopperState", "tooltipContent", "onEnterTooltip", "onLeaveTooltip", "align"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState, useRef } from 'react';
import classnames from 'classnames';
import TableCell from '@mui/material/TableCell';
import { ThemeProvider } from '@mui/material/styles';
import { tableCellTheme } from './tableCellStyles';
import { isFirefox } from '../../../../utils/string';
import { TableCellTooltip } from './tableCellTooltip';
export var EmbersTableCell = function EmbersTableCell(_ref) {
  var children = _ref.children,
    className = _ref.className,
    shouldShowTooltip = _ref.shouldShowTooltip,
    getTooltipPopperState = _ref.getTooltipPopperState,
    tooltipContent = _ref.tooltipContent,
    onEnterTooltip = _ref.onEnterTooltip,
    onLeaveTooltip = _ref.onLeaveTooltip,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipAnchorEl = _useState2[0],
    setTooltipAnchorEl = _useState2[1];
  var timeout = useRef(0);
  var showTooltip = function showTooltip(target) {
    timeout.current = window.setTimeout(function () {
      setTooltipAnchorEl(target);
    }, 500);
  };
  var onMouseEnter = function onMouseEnter(e) {
    var target = e.currentTarget;
    var actuallyTarget = e.target;
    // avoid Modal trigger mouse enter event
    if (actuallyTarget.classList.contains('MuiBackdrop-root') || actuallyTarget.classList.contains('MuiDialog-container')) {
      return;
    }
    if (shouldShowTooltip) {
      shouldShowTooltip(target) && showTooltip(target);
      return;
    }
    if (target.clientWidth < target.scrollWidth) {
      showTooltip(target);
    } else {
      var nodes = target.querySelectorAll('*');
      if (nodes && nodes.length > 0) {
        var nodesArray = Array.from(nodes);
        for (var i = 0; i < nodesArray.length; i++) {
          var ele = nodesArray[i];
          // in firefox the inline element's clientWidth would be 0,
          //  and offsetWidth would equal scrollWidth when no overflow,
          //  so use offsetWidth in firefox
          //@ts-ignore
          var width = isFirefox(navigator.userAgent) ? ele.offsetWidth : ele.clientWidth;
          // only calc visible element
          if (width > 0 && width < ele.scrollWidth) {
            showTooltip(target);
            break;
          }
        }
      }
    }
  };
  var clearTooltip = function clearTooltip() {
    setTooltipAnchorEl(null);
    clearTimeout(timeout.current);
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: tableCellTheme
  }, /*#__PURE__*/React.createElement(TableCell, _extends({
    className: classnames('EmbersTableCell-root', className),
    align: align
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: clearTooltip,
    onClick: function onClick(e) {
      var target = e.target;
      if (target.classList.contains('EmbersTableCell-popper-container')) {
        e.stopPropagation();
      } else {
        clearTooltip();
      }
    }
  }, children, /*#__PURE__*/React.createElement(TableCellTooltip, {
    anchorEl: tooltipAnchorEl,
    getPopperState: getTooltipPopperState,
    onMouseEnter: onEnterTooltip,
    onMouseLeave: onLeaveTooltip
  }, tooltipContent !== null && tooltipContent !== void 0 ? tooltipContent : children))));
};